import { NavbarRouteList } from "./types";

export const PROD_LINKS: NavbarRouteList = [
  { name: "Home", route: "/" },
  { name: "About", route: "/about" },
  { name: "Impacts", route: "/impacts" },
  { customNavItem: true, customNavItemId: "explore" },
  {
    name: "Tools",
    routes: [
      {
        route: `external/${encodeURIComponent(
          "https://experience.arcgis.com/experience/452a09a2c314415fa1bc9d8ec71b05d1/"
        )}`,
        name: "4-H Data Dashboard",
      },
      { route: "/landing-page/profiles", name: "Community Profiles" },
      {
        route: `external/${encodeURIComponent(
          "https://cornsilage.kx.osu.edu/"
        )}`,
        name: "Corn Silage Pricing",
      },
      // { route: "/data-catalog", name: "Data Catalog" },
      { route: "/expert-directory", name: "Expert Directory" },
      { route: "/food-system-tool", name: "Food System Map" },
      { route: "/landing-page/knowledge-explorer", name: "Knowledge Explorer" },
      {
        name: "Precision Ag",
        routes: [
          {
            route: `external/${encodeURIComponent(
              "https://eprograms.kx.osu.edu/efields"
            )}`,
            name: "eFields",
          },
          {
            route: `external/${encodeURIComponent(
              "https://eprograms.kx.osu.edu/ebarns"
            )}`,
            name: "eBarns",
          },
        ],
        dropdownMenu: true,
      },
      {
        route: `external/${encodeURIComponent(
          "https://recipes.kx.osu.edu/"
        )}`,
        name: "RECIPES",
      },
    ],
    dropdownMenu: true,
  },
  {
    name: `<i class="fa fa-search"></i>`,
    route: "/search",
    label: "search",
  },
];
export const DEV_LINKS: NavbarRouteList = [
  { name: "Home", route: "/" },
  { name: "About", route: "/about" },
  { name: "Impacts", route: "/impacts" },
  { customNavItem: true, customNavItemId: "explore" },
  {
    name: "Tools",
    routes: [
      {
        route: `external/${encodeURIComponent(
          "https://experience.arcgis.com/experience/452a09a2c314415fa1bc9d8ec71b05d1/"
        )}`,
        name: "4-H Data Dashboard",
      },
      { route: "/landing-page/profiles", name: "Community Profiles" },
      {
        route: `external/${encodeURIComponent(
          "https://cornsilage.kx.osu.edu/"
        )}`,
        name: "Corn Silage Pricing",
      },
      { route: "/data-catalog", name: "Data Catalog" },
      { route: "/expert-directory", name: "Expert Directory" },
      { route: "/food-system-tool", name: "Food System Map" },
      { route: "/landing-page/knowledge-explorer", name: "Knowledge Explorer" },
      {
        name: "Precision Ag",
        routes: [
          {
            route: `external/${encodeURIComponent(
              "https://eprograms.kx.osu.edu/efields"
            )}`,
            name: "eFields",
          },
          {
            route: `external/${encodeURIComponent(
              "https://eprograms.kx.osu.edu/ebarns"
            )}`,
            name: "eBarns",
          },
        ],
        dropdownMenu: true,
      },
      {
        route: `external/${encodeURIComponent(
          "https://recipes.kx.osu.edu/"
        )}`,
        name: "RECIPES",
      },
    ],
    dropdownMenu: true,
  },
  {
    name: `<i class="fa fa-search"></i>`,
    route: "/search",
    label: "search",
  },
];

export const ROUTE_CONDITIONAL_LINKS: NavbarRouteList = [
  { customNavItem: true, customNavItemId: "explorer-cart" },
];
